import { createStyles, Theme } from '@material-ui/core/styles';

const styles = (theme: Theme) =>
  createStyles({
    animation: {
      animation: 'animation-shimmering 1.5s linear infinite',
      backgroundColor: theme.custom.palette.grey4,
      backgroundImage: `linear-gradient(-90deg, ${theme.custom.palette.grey4} 0%, ${theme.custom.palette.grey3} 50%, ${theme.custom.palette.grey4} 100%)`,
      backgroundPosition: '-300px 0',
      backgroundRepeat: 'no-repeat',
      backgroundSize: '300px 100%',
    },
    divider: {
      backgroundColor: theme.custom.palette.grey4,
    },
  });

export default styles;
